export default function PageTransition({ children }) {
  return (
    <div className="h-[calc(100vh-60px)] overflow-hidden">
      <div className="bg-slate-50 p-6 h-full overflow-auto flex">
        {children}
      </div>
    </div>
  );
}
